import scrollToTop from "./scrollToTop";

const selectProd = (prod, searchParams, setSearchParams, step, setSteps) => {
    if(prod.compatible === false) return;

    searchParams.set('step', Number(searchParams.get('step')) + 1);
    searchParams.set(step.tag, prod.id);
    setSearchParams(searchParams, { replace: true });

    scrollToTop();
    
    setSteps(prevSteps => prevSteps.map(prevStep => prevStep.id === step.id ? {...prevStep, data: {...prod, cantidad: 1}} : prevStep))
}

export default selectProd;